angular.module("digiexam.components").directive("course", function courseDirective() {
	"use strict";
	return {
		restrict: "E",
		scope: {course: "="},
		templateUrl: "directives/course.html",
		replace: true,

		link: function link($scope, element) {
			if (!$scope.course.externallyManaged && $scope.course.integrationSource === 0) {
				element.droppable({
					accept: ".group",
					over: function over(event, ui) {
						var id = parseInt(ui.helper.data("id"), 10);
						if ($scope.course.groups && $scope.course.groups.length > 0) {
							for (var i = 0; i < $scope.course.groups.length; i++) {
								if ($scope.course.groups[i].id === id) {
									return;
								}
							}
						}
						ui.helper.addClass("over");
						element.addClass("class-hovering");
					},
					out: function out(event, ui) {
						var id = parseInt(ui.helper.data("id"), 10);
						if ($scope.course.groups && $scope.course.groups.length > 0) {
							for (var i = 0; i < $scope.course.groups .length; i++) {
								if ($scope.course.groups[i].id === id) {
									return;
								}
							}
						}
						ui.helper.removeClass("over");
						element.removeClass("class-hovering");
					},
					drop: function drop(event, ui) {
						var id = parseInt(ui.helper.data("id"), 10);
						if ($scope.course.groups && $scope.course.groups.length > 0) {
							for (var i = 0; i < $scope.course.groups .length; i++) {
								if ($scope.course.groups[i].id === id) {
									return;
								}
							}
						}
						var grouptitle = ui.helper.data("title");
						element.removeClass("class-hovering");
						$scope.addClass(id, grouptitle);
					},
				});
			}
		},
		controller: function controller($scope, $rootScope, $location, course, faults, dxDialog, dxLocalize) {
			$scope.addClass = function addClass(groupId, groupTitle) {
				var promise = course.addGroup($scope.course.id, groupId);
				return promise.then(function success(response) {
					if (!response.faults) {
						if (!$scope.course.groups) {
							$scope.course.groups = [];
						}
						$scope.course.groups.push({id: groupId, title: groupTitle, draggable: false});
					}
				});
			};

			$scope.finishCreateGroup = function finishCreateGroup(id) {
				return $location.path("/class/" + id + "/edit");
			};

			$scope.canSubmit = function canSubmit() {
				if ($scope.newGroupNameText && $scope.newGroupNameText.length > 2) {
					return true;
				}
				return false;
			};

			$scope.hasArchivedGroups = function hasArchivedGroups() {
				if (!$scope.course.groups) {
					return false;
				}

				for (var i = 0; i < $scope.course.groups.length; i++) {
					var g = $scope.course.groups[i];
					if (g.isArchived && g.type === 0) {
						return true;
					}
				}
				return false;
			};

			$scope.isArchived = function isArchived(g) {
				return g.isArchived;
			};

			$scope.isArchivedGroup = function isArchivedGroup(g) {
				return g.isArchived && g.type === 0;
			};

			$scope.editCourse = function editCourse(editedCourse) {
				var strippedScope = $rootScope.$new();
				strippedScope.course = editedCourse;
				dxDialog.show({
					templateUrl: "/partials/popups/editcourse.html",
					$scope: strippedScope,
				});
			};

			$scope.showLMSInfo = function showLMSInfo() {
				dxDialog.alert({
					title: dxLocalize.get("Course.LMSManaged.title"),
					body: "<p class='mb-400'>" + dxLocalize.get("Course.LMSManaged.paragraph.1") + "</p>" + dxLocalize.get("Course.LMSManaged.paragraph.2"),
					acceptText: dxLocalize.get("Close"),
				});
			};

			$scope.showSkolonInfo = function showSkolonInfo() {
				dxDialog.alert({
					title: dxLocalize.get("Course.SkolonManaged.title"),
					body: "<p class='mb-400'>" + dxLocalize.get("Course.SkolonManaged.paragraph.1") + "</p>" + dxLocalize.get("Course.SkolonManaged.paragraph.2"),
					acceptText: dxLocalize.get("Close"),
				});
			};
		},
	};
});
